import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-slider-side-menu',
  templateUrl: './slider-side-menu.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgIf
  ],
  styleUrls: ['./slider-side-menu.component.scss']
})
export class SliderSideMenuComponent implements OnInit {

  @Input() isShow = false

  constructor() { }

  ngOnInit(): void {

  }

}
